import { render, staticRenderFns } from "./AddAndEditStaffDialog.vue?vue&type=template&id=72b49290&scoped=true&"
import script from "./AddAndEditStaffDialog.vue?vue&type=script&lang=js&"
export * from "./AddAndEditStaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddAndEditStaffDialog.vue?vue&type=style&index=0&id=72b49290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b49290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VTextField})
